<template>
  <div>
      <material-card icon="mdi-clipboard-text" title="Ticket List">
        <v-card flat class="px-2">
          <v-row>
            <v-col v-if="!isFranchiseeUser" cols="12" md="6" lg="2">
              <label class="body-2 font-weight-medium">Select Zone</label>
              <v-autocomplete
                key="id"
                placeholder="Select Zone"
                :items="zones"
                v-model="selectedZones"
                item-value="name"
                item-text="name"
                hide-details
                clearable
                @change="getFranchiseeList()"
                @click:clear="resetFranchiseeArr()"
                class="pt-0 mt-2"
              >
              </v-autocomplete>
            </v-col>
            <v-col v-if="!isFranchiseeUser" cols="12" md="6" lg="2">
              <label class="body-2 font-weight-medium">Select Franchisee</label>
              <v-autocomplete
                :items="franchiseeArr"
                v-model="franchiseeSelect"
                item-text="companyName"
                item-value="id"
                hide-details
                placeholder="Select Franchisee"
                class="pt-0 mt-2"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" :lg="isFranchiseeUser ? 3 : 2">
              <label class="body-2 font-weight-medium">Query Related To</label>
              <v-autocomplete
                :items="queryRelatedToInfo"
                v-model="queryRelatedToId"
                item-text="label"
                item-value="id"
                placeholder="Query Releated To"
                hide-details
                class="pt-0 mt-2"
                @change="getQueryTypeList"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" :lg="isFranchiseeUser ? 3 : 2">
              <label class="body-2 font-weight-medium">Query Type</label>
              <v-autocomplete
                :items="queryTypeInfo"
                v-model="queryTypeId"
                item-text="label"
                item-value="id"
                placeholder="Query Type"
                hide-details
                class="pt-0 mt-2"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" lg="2">
              <label class="body-2 font-weight-medium">Assigned To</label>
              <v-autocomplete
                :items="assignee"
                v-model="assigneeId"
                item-text="fullName"
                item-value="id"
                placeholder="Assigned To"
                hide-details
                class="pt-0 mt-2"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" lg="2">
              <label class="body-2 font-weight-medium">Status</label>
              <v-select
                :items="statusArray"
                v-model="selectedTicketStatus"
                item-text="text"
                item-value="value"
                placeholder="Status"
                hide-details
                class="pt-0 mt-2"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" lg="2">
              <label class="body-2 font-weight-medium">Priority</label>
              <v-select
                :items="priorities"
                v-model="priorityId"
                item-text="name"
                item-value="id"
                placeholder="Priority"
                hide-details
                class="pt-0 mt-2"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" lg="3">
              <label class="body-2 font-weight-medium">Select:</label>
              <v-radio-group
                class="mt-5 pt-0"
                hide-details
                v-model="radioSelect"
                row
              >
                <v-radio name="active" label="Datewise" :value="1"></v-radio>
                <v-radio name="active" label="Daywise" :value="0"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col v-if="radioSelect" cols="12" md="6" lg="2">
              <label class="body-2 font-weight-medium"> From date</label>
              <div class="mt-1">
                <custom-date-picker
                  :maxToDate="maxToDate"
                  v-model.trim="fromDateFilter"
                  hide-details
                />
              </div>
            </v-col>
            <v-col v-if="radioSelect" cols="12" md="6" lg="2">
              <label class="body-2 font-weight-medium"> To date</label>
              <div class="mt-1">
                <custom-date-picker
                  :minToDate="fromDateFilter"
                  v-model.trim="toDateFilter"
                  hide-details
                />
              </div>
            </v-col>
            <v-col v-else cols="12" md="6" lg="2">
              <label class="body-2 font-weight-medium">Ticket Age</label>
              <v-select
                :items="numbers"
                v-model="ticketAge"
                placeholder="Ticket Age"
                hide-details
                class="pt-0 mt-2"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6" lg="2">
              <label class="body-2 font-weight-medium">Search by ID</label>
              <v-text-field
                v-model="search"
                placeholder="Search by ID"
                hide-details
                class="pt-0 mt-2"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0" cols="12" md="12" lg="12">
              <v-card-actions class="px-0 d-flex" :class="$vuetify.breakpoint.smAndUp ? 'justify-end' : 'justify-start'">
                <v-btn
                  mediun
                  color="primary"
                  type="submit"
                  small
                  @click="
                    () => {
                      (page = 1),
                      getTicketingListing()
                    }
                  "
                >
                  <v-icon left> mdi-plus </v-icon>
                  Apply
                </v-btn>
                <v-btn
                  mediun
                  color="primary"
                  type="submit"
                  @click="clear()"
                  small
                >
                  <v-icon left> mdi-close </v-icon>
                  Clear
                </v-btn>
              </v-card-actions>
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="12" lg="12">
              <v-card-actions class="px-0 pt-0 d-flex justify-start">
                <router-link :to="{ name: 'beesTicketingAdmin' }">
                  <v-btn
                    class="mr-4"
                    v-if="$vuetify.breakpoint.smAndUp"
                    color="success"
                    elevation="1"
                  >
                    <v-icon left>mdi-ticket-account</v-icon>
                    Create Ticket
                  </v-btn>
                  <v-btn v-else color="success" fab small elevation="1">
                    <v-icon>mdi-ticket-account</v-icon></v-btn
                  >
                </router-link>
                <v-btn
                  class="mr-4"
                  :disabled="!(TicketingListInfo.length > 0)"
                  @click="exportToCSV()"
                  v-if="$vuetify.breakpoint.smAndUp"
                  color="primary"
                  elevation="1"
                >
                  <v-icon left>mdi-download</v-icon>
                  Export All
                </v-btn>
                <v-btn
                  :disabled="!(TicketingListInfo.length > 0)"
                  @click="exportToCSV()"
                  class="ml-4"
                  v-else
                  color="primary"
                  fab
                  small
                  elevation="1"
                >
                  <v-icon>mdi-download</v-icon></v-btn
                >
                <router-link :to="{ name: 'Dashboard' }">
                  <v-btn
                    v-if="$vuetify.breakpoint.smAndUp"
                    dark
                    color="pink"
                    elevation="1"
                  >
                    <v-icon left>mdi-view-dashboard</v-icon>
                    Dashboard</v-btn
                  >
                  <v-btn
                    v-else
                    color="pink"
                    class="ml-4"
                    dark
                    fab
                    small
                    elevation="1"
                  >
                    <v-icon>mdi-view-dashboard</v-icon></v-btn
                  >
                </router-link>
              </v-card-actions>
            </v-col>
            <v-col class="px-0" cols="12" md="12" lg="12" xs="12">
              <v-card class="pa-0" elevation="0" outlined>
                <v-card-text class="pa-1">
                  <v-data-table
                    :headers="headers"
                    :items="searchFilterArray"
                    disable-pagination
                    :hide-default-footer="true"
                  >
                    <template v-slot:item.ticketcode="{ item }">
                      <v-btn
                        small
                        class="px-2 ml-1 ma-1"
                        min-width="0"
                        color="primary"
                        @click="goToTicket(item)"
                      >
                        <span class="font-weight-bold"> {{ item.ticketcode }}</span>
                      </v-btn>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <span :class="getColor(item.status)">
                        {{ item.status }}
                      </span>
                    </template>
                    <template v-slot:item.priority.name="{ item }">
                      <span :class="getColor(item.priority.name)">
                        {{ item.priority.name }}
                      </span>
                    </template>
                    <template v-slot:item.AssigneeTo="{ item }">
                      {{
                        item.assignee &&
                        item.assignee.firstName &&
                        item.assignee.lastName
                          ? item.assignee.firstName + ' ' + item.assignee.lastName
                          : '-'
                      }}
                    </template>
                    <template v-slot:item.department="{ item }">
                      {{ item.assignee.department ? item.assignee.department : '-' }}
                    </template>
                    <template v-slot:item.franchiseDetails="{ item }">
                      <div v-if="item && item.franchiseDetails">
                        <div v-if="item.franchiseDetails.franchiseeEmail && item.franchiseDetails.franchiseeMobileno && item.franchiseDetails.franchiseeAddress">
                          <span><b>Email:</b> {{ item.franchiseDetails.franchiseeEmail }}</span></br>
                          <span><b>Phone:</b> {{ item.franchiseDetails.franchiseeMobileno }}</span></br>
                          <span><b>Address:</b> {{ item.franchiseDetails.franchiseeAddress }}</span></br>
                        <span><b>website:</b> {{ item.franchiseDetails?.website || 'Not available' }}</span><br>
                        </div>
                        <p v-else>-</p>
                      </div>
                    </template>

                    <template v-slot:no-data>
                      <v-card-subtitle class="d-flex justify-center"
                        >No Data Available</v-card-subtitle
                      >
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="searchFilterArray.length != 0">
            <v-col class="py-2 px-4" cols="12" md="4" lg="4" xs="12" sm="12">
              <v-select
                v-model="pageSize"
                :items="pageSizes"
                label="Items per Page"
                hide-details
                @change="handlePageSizeChange"
              ></v-select>
            </v-col>
            <v-col cols="12" md="8" lg="8" xs="12" sm="12">
              <v-pagination
                class="mx-2"
                v-model="page"
                :length="totalPages"
                :total-visible="10"
                @input="handlePageChange"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-card>
      </material-card>
  </div>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import moment from 'moment'
import ExportUtility from '@/utils/exportUtility'
import _ from 'lodash'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import stores from '@/stores'
export default {
  name: 'ListTicketigUser',
  components: {
    MaterialCard,
    CustomDatePicker
  },
  props: ['ticketstatus', 'franchiseeID'],

  data () {
    return {
      data: [],
      delay: [],
      current: 1,
      rangeBefore: 3,
      rangeAfter: 1,
      order: 'is-right',
      size: '',
      search: '',
      total: '',
      isSimple: false,
      isRounded: false,
      prevIcon: 'chevron-left',
      nextIcon: 'chevron-right',
      isModalActive: false,
      trashObject: null,
      isLoading: false,
      paginated: false,
      perPage: 10,
      franchiseeSelect: '',
      loadingComponent: null,
      headers: [
        { text: 'Ticket Id', value: 'ticketcode', sortable: true },
        { text: 'Query Related', value: 'queryrelatedtodeptname', sortable: true },
        { text: 'Query Type', value: 'querytypename', sortable: true },
        { text: 'Priority', value: 'priority', sortable: true },
        { text: 'Zone', value: 'zone', sortable: true },
        { text: 'Franchisee', width: '200px', value: 'franchisename', sortable: true },
        { text: 'Subject', value: 'ticketname', sortable: false },
        { text: 'Assigned To', value: 'allocatedtoname', sortable: true },
        { text: 'Department', value: 'queryrelatedtodeptname', sortable: true },
        { text: 'Ticket Status', value: 'status', sortable: true },
        { text: 'Last Modified By', value: 'lastmodifiedby', sortable: false },
        { text: 'Created Date', value: 'createddate', sortable: true },
        { text: 'Franchisee Contact Info', value: 'franchiseDetails', sortable: false }
      ],
      franchiseeArr: [],
      TicketingListInfo: [],
      searchTerm: '',
      searchFilterArray: [],
      queryRelatedToInfo: [],
      queryTypeInfo: [],
      assignee: [],
      queryRelatedToId: '',
      queryTypeId: '',
      assigneeId: '',
      priorityId: '',
      priorities: [],
      fromDateFilter: null,
      toDateFilter: null,
      ticketAge: null,
      maxToDate: moment().format('YYYY-MM-DD'),
      readonlyflag: true,
      radioSelect: 1,
      numbers: [0, 1, 2, 3, 4, 5, 6, 7],
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 50, 100],
      zones: [],
      selectedZones: '',
      statusArray: [
        { text: 'Open', value: 'open' },
        { text: 'Closed', value: 'closed' }
      ],
      selectedTicketStatus: this.ticketstatus || 'open',
      isFranchiseeUser: false
    }
  },

  async created () {
    this.isFranchiseeUser = stores.user.me.isFranchiseeUser
    this.selectedTicketStatus = this.ticketstatus || 'open'
    this.franchiseeSelect = this.franchiseeID || ''
    await this.getZoneDetails()
    if (this.isFranchiseeUser && this.zones.length > 0) {
      this.selectedZones = this.zones[0].name
      await this.getFranchiseeList()
      if (this.franchiseeArr.length > 0) {
        this.franchiseeSelect = this.franchiseeArr[0].id
      }
    }
    await this.getTicketingListing()
    await this.getQueryRelatedList()
    await this.getAssigneeList()
  },

  methods: {
    goToTicket (item) {
      if (item?.franchiseeFilter) {
        sessionStorage.setItem('franchiseeFilter', item.franchiseeFilter)
      } else {
        sessionStorage.removeItem('franchiseeFilter')
      }
      this.$router.push({
        name: 'beesTicketingAction',
        params: { id: item.ticketid }
      })
    },
    getColor (status) {
      if (status === 'closed') return 'v-green font-weight-bold'
      else if (status === 'open') return 'v-error font-weight-bold'
      else if (status === 'High') return 'v-darkblue font-weight-bold'
      else if (status === 'Low') return 'v-warning font-weight-bold'
      else if (status === 'Moderate') return 'v-info font-weight-bold'
      else return 'v-secondary '
    },
    getAssigneeList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/sbTicketing/get-info`)
        if (res.status === 200 && res.data.length > 0) {
          this.assignee = res.data
        }
        this.assignee.forEach(item => {
          item.fullName = `${item.firstName} ${item.lastName}`
        })
        this.assigneeId = ''
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    getTicketingListing: async function () {
      try {
        this.isLoading = true
        let queryParams = {}
        if (this.selectedTicketStatus) {
          queryParams.status = this.selectedTicketStatus
        }
        if (this.assigneeId) {
          queryParams.assignto = this.assigneeId
        }
        if (this.priorityId) {
          _.map(this.priorities, (item) => {
            if (item.id === this.priorityId) {
              queryParams.priority = item.name
            }
          })
        }
        if (this.fromDateFilter) {
          queryParams.datefrom = this.fromDateFilter
        }
        if (this.toDateFilter) {
          queryParams.dateto = this.toDateFilter
        }
        if (this.franchiseeSelect) {
          _.map(this.franchiseeArr, (item) => {
            if (item.id === this.franchiseeSelect) {
              queryParams.franchiseeName = item.companyName
              queryParams.franchiseeID = item.id
            }
          })
        }
        if (this.queryRelatedToId) {
          queryParams.queryrelatedtodept = this.queryRelatedToId
        }
        if (this.queryTypeId) {
          queryParams.querytype = this.queryTypeId.toString()
        }
        if (this.search) {
          queryParams.ticketcode = this.search
        }

        // Start Pending Field
        if (this.selectedZones) {
          queryParams.zone = this.selectedZones
        }

        if (this.ticketAge || this.ticketAge === 0) {
          queryParams.ticketAge = this.ticketAge
        }
        // End Pending Field

        queryParams.limit = this.pageSize
        queryParams.offset = this.page
        // queryParams.offset = 1
        const res = await http.post(`${constants.API_URL}/api/sbTicketing/getTicketsList`, queryParams)
        if (res.status === 200) {
          if (res.data.status) {
            this.TicketingListInfo = res.data.data.rows
            this.searchFilterArray = res.data.data.rows
            this.searchFilterArray.forEach(row => {
              row.createddate = row.createddate ? moment(row.createddate, 'YYYY-MM-DDThh:mm:ss').format('DD-MMM-YYYY HH:mm') : ''
            })
            this.totalPages = Math.ceil(res.data.data.count / this.pageSize)
            this.total = this.TicketingListInfo.length
            this.paginated = !!this.total
          } else {
            this.TicketingListInfo = []
            this.searchFilterArray = []
            this.totalPages = 0
            this.total = this.TicketingListInfo.length
            this.paginated = !!this.total
          }
          this.isLoading = false
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true
        let zone = []
        if (this.selectedZones) {
          zone = [this.selectedZones]
        }
        if (zone.length > 0) {
          const response = await http.post(
            `${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`,
            {
              zone: zone
            }
          )
          let data = response.data
          this.franchiseeArr = _.map(data, (e) => {
            if (e.id) {
              if (e.id.toString().length === 1) {
                e.companyName = `${'(00' + e.id + ')'} ` + e.companyName
              } else if (e.id.toString().length === 2) {
                e.companyName = `${'(0' + e.id + ')'} ` + e.companyName
              } else {
                e.companyName = `${'(' + e.id + ')'} ` + e.companyName
              }
              e.companyName = e.region
                ? e.companyName + `${' (' + e.region + ')'}`
                : e.companyName
            }
            return e
          })
        } else {
          this.franchiseeArr = []
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getQueryRelatedList: async function () {
      try {
        let queryParam = {}
        const res = await http.post(`${constants.API_URL}/api/sbTicketing/getQueryRelatedToList`, queryParam)
        if (res.status === 200) {
          this.queryRelatedToInfo = res.data.QueryRelatedTo.data
          this.priorities = res.data.priorityList
          this.priorities.forEach(item => {
            if (item.name === 'Moderate') {
              item.name = 'Medium'
            }
          })
          let temp = this.priorities[1]
          this.priorities[1] = this.priorities[2]
          this.priorities[2] = temp
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    getQueryTypeList: async function () {
      if (this.queryRelatedToId) {
        try {
          let payload = {}
          payload.projectmoduleid = parseInt(this.queryRelatedToId)
          const res = await http.post(`${constants.API_URL}/api/sbTicketing/getQueryTypeList`, payload)
          if (res.status === 200) {
            if (res.data.status) {
              this.queryTypeInfo = res.data.data
            } else {
              this.$dialog.error({
                title: 'Error',
                text: res.data.msg
              })
            }
          }
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          return this.$dialog.error({
            title: 'Error',
            text: errorMessage
          })
        }
      } else {
        this.queryType = []
      }
    },
    handlePageChange (value) {
      this.page = value
      this.getTicketingListing()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getTicketingListing()
    },
    exportToCSV: async function () {
      this.isLoading = true
      let queryParams = {}
      if (this.selectedTicketStatus) {
        queryParams.status = this.selectedTicketStatus
      }
      if (this.assigneeId) {
        queryParams.assignto = this.assigneeId
      }
      if (this.priorityId) {
        _.map(this.priorities, (item) => {
          if (item.id === this.priorityId) {
            queryParams.priority = item.name
          }
        })
      }
      if (this.fromDateFilter) {
        queryParams.datefrom = this.fromDateFilter
      }
      if (this.toDateFilter) {
        queryParams.dateto = this.toDateFilter
      }
      if (this.franchiseeSelect) {
        _.map(this.franchiseeArr, (item) => {
          if (item.id === this.franchiseeSelect) {
            queryParams.franchiseeName = item.companyName
            queryParams.franchiseeID = item.id
          }
        })
      }
      if (this.queryRelatedToId) {
        queryParams.queryrelatedtodept = this.queryRelatedToId
      }
      if (this.queryTypeId) {
        queryParams.querytype = this.queryTypeId.toString()
      }
      if (this.search) {
        queryParams.ticketcode = this.search
      }
      // Start Pending Field
      if (this.selectedZones) {
        queryParams.zone = this.selectedZones
      }

      if (this.ticketAge || this.ticketAge === 0) {
        queryParams.ticketAge = this.ticketAge
      }
      // End Pending Field
      try {
        const res = await http.post(`${constants.API_URL}/api/sbTicketing/getTicketsList`, queryParams)
        if (res.status === 200) {
          if (res.data.status) {
            this.TicketingListInfo = res.data.data.rows
            this.searchFilterArray = res.data.data.rows
            this.totalPages = Math.ceil(res.data.data.count / this.pageSize)
            this.total = this.TicketingListInfo.length
            this.paginated = !!this.total
            let csvData = []
            this.TicketingListInfo.forEach((t, index) => {
              csvData.push({
                SRNo: index + 1,
                TicketCode: t.ticketcode,
                QueryRelated: t.queryrelatedtodeptname ? t.queryrelatedtodeptname : null,
                QueryType: t.querytypename ? t.querytypename : null,
                Zone: t.zone ? t.zone : '-',
                Franchisee: t.vendorcode ? t.vendorcode : '-',
                FranchiseeName: t.franchisename ? t.franchisename : '-',
                Subject: t.ticketname ? t.ticketname : '-',
                AssigneeTo: t && t.assigntoemailid ? t.assigntoemailid : '',
                Department: t && t.queryrelatedtodeptname ? t.queryrelatedtodeptname : '-', // t && t.assigneedeptname ? t.assigneedeptname : '-',
                TicketStatus: t.status,
                LastModifiedBy: t.lastmodifiedby,
                CreatedDate: t.createddate,
                LastModifiedDate: t.lastmodifieddate
              })
            })
            ExportUtility.convertToCsv(csvData, this.selectedTicketStatus)
            this.getTicketingListing()
          } else {
            return this.$dialog.error({
              title: 'Error',
              text: res.data.msg
            })
          }
          this.isLoading = false
        }
      } catch (e) {
        this.isLoading = false
        console.error('Error exporting tickets')
        this.$dialog.error({
          title: 'Error',
          text: 'Failed to export tickets'
        })
      }
    },
    clear () {
      this.selectedZones = ''
      this.franchiseeSelect = ''
      this.franchiseeArr = []
      this.queryRelatedToId = ''
      this.assigneeId = ''
      this.fromDateFilter = ''
      this.toDateFilter = ''
      this.ticketAge = ''
      this.queryTypeId = ''
      this.queryTypeInfo = []
      this.priorityId = ''
      this.search = ''
      this.page = 1
      this.getTicketingListing()
    },
    resetFranchiseeArr: function () {
      this.franchiseeSelect = ''
      this.franchiseeArr = []
    },
    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-zones`
        )
        this.zones = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
